export const MODE_SECTION_ID = 'workflow-mode';

export const MODE_OPTIONS = [
    { value: 'builder', label: 'Builder' },
    { value: 'runner', label: 'Runner' },
] as const;
